module.exports = __webpack_public_path__ + "static/media/agiplogo@2x.69e24b3d.png";